import React from "react";

export const CookieContext = React.createContext<string | null>(null);